// extracted by mini-css-extract-plugin
export var container = "OrganizationCard-module--container--d845a";
export var description = "OrganizationCard-module--description--6368c";
export var header = "OrganizationCard-module--header--1a9d6";
export var headerContent = "OrganizationCard-module--headerContent--d7526";
export var logo = "OrganizationCard-module--logo--8c99c";
export var logoContainer = "OrganizationCard-module--logoContainer--ae726";
export var tagsContainer = "OrganizationCard-module--tagsContainer--10cd4";
export var titleLink = "OrganizationCard-module--titleLink--59ed4";